import { Vector2 } from 'three';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';

import cameraManager from '../../camera-manager';

export const lineMaterial = {
  accent: new LineMaterial({
    color: 0xfed530,
    linewidth: 4,
    // resolution - updated regularly on animate
    dashed: false,
    depthTest: false,
    transparent: true,
    opacity: 1,
  }),

  background: new LineMaterial({
    color: 0,
    linewidth: 6,
    // resolution - updated regularly on animate
    dashed: false,
    depthTest: false,
    transparent: true,
    opacity: 1,
  }),

  focusedBackground: new LineMaterial({
    color: 0,
    linewidth: 10,
    // resolution - updated regularly on animate
    dashed: false,
    depthTest: false,
    transparent: true,
    opacity: 1,
  }),

  hovered: new LineMaterial({
    color: 0x6385f1,
    linewidth: 6,
    // resolution - updated regularly on animate
    dashed: false,
    depthTest: false,
    transparent: true,
    opacity: 1,
  }),

  selected: new LineMaterial({
    color: 0xb3ff81,
    linewidth: 6,
    // resolution - updated regularly on animate
    dashed: false,
    depthTest: false,
    transparent: true,
    opacity: 1,
  }),
};

/**
 *  Sets the resolution for the materials. This is used internally in the shaders to generate the line width effect.
 */
export const updateLineMaterials = () => {
  lineMaterial.accent.resolution = new Vector2(
    cameraManager().getCanvasWidth(),
    cameraManager().getCanvasHeight(),
  );
  lineMaterial.background.resolution = new Vector2(
    cameraManager().getCanvasWidth(),
    cameraManager().getCanvasHeight(),
  );
  lineMaterial.focusedBackground.resolution = new Vector2(
    cameraManager().getCanvasWidth(),
    cameraManager().getCanvasHeight(),
  );
  lineMaterial.hovered.resolution = new Vector2(
    cameraManager().getCanvasWidth(),
    cameraManager().getCanvasHeight(),
  );
  lineMaterial.selected.resolution = new Vector2(
    cameraManager().getCanvasWidth(),
    cameraManager().getCanvasHeight(),
  );
};
